import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

import consumerDocuments from './consumer-documents.mock.json';

const mock = new AxiosMockAdapter(instance, { delayResponse: 2000 });

mock
  .onGet(/\/api\/consumer-documents\/query.*/)
  .reply(200, consumerDocuments)
  .onAny()
  .passThrough();
